exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "/*\nStylesheet for the page to list the exemplary business models.\n@author Adrian Rebmann, Steffen Schuhmann, Andrea Villeda\n*/\n.margin-twenty {\n  margin-bottom: 20px;\n}\n.md-subhead {\n  min-height: 70px;\n}\n", "", {"version":3,"sources":["/home/gitlab-runner/builds/b21bf5d0/0/mkz/werner-frontend/src/components/company/businessmodel/example/bmexample.css"],"names":[],"mappings":"AAAA;;;EAGE;AAEF;EACE,oBAAoB;CACrB;AAED;EACE,iBAAiB;CAClB","file":"bmexample.css","sourcesContent":["/*\nStylesheet for the page to list the exemplary business models.\n@author Adrian Rebmann, Steffen Schuhmann, Andrea Villeda\n*/\n\n.margin-twenty {\n  margin-bottom: 20px;\n}\n\n.md-subhead {\n  min-height: 70px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-42302abc","scoped":false,"hasInlineConfig":false}!./src/components/company/businessmodel/example/bmexample.css
// module id = X8nf
// module chunks = 1